<pbc-sorter [config]="ProjektArtsSorterConfig" [sorter]="projektArts.sorter$ | async" (sorterChange)="projektArts.sorter$.next($event)"></pbc-sorter>
